import { adPlacements } from './placements';
import type { AdPlacement, AdPlacementId, AdProvider, AdShowResult } from './types';

type AdPlacementTable = Readonly<Record<AdPlacementId, AdPlacement>>;

export class AdsService {
  private showing = false;

  constructor(
    private readonly provider: AdProvider,
    private readonly placements: AdPlacementTable = adPlacements,
  ) {}

  async show(id: AdPlacementId): Promise<AdShowResult> {
    const placement = this.placements[id];
    if (!placement.enabled) {
      return 'unavailable';
    }
    if (this.showing) {
      return 'cancelled';
    }

    this.showing = true;
    try {
      return await this.provider.show(placement);
    } catch {
      return 'failed';
    } finally {
      this.showing = false;
    }
  }
}
